import { Component, inject, signal, ViewChild, WritableSignal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { JobsService } from '../../services/jobs.service';
import { Router, RouterModule } from '@angular/router';
import { JobCardComponent } from './job-card/job-card.component';
import { finalize } from 'rxjs';
import { MatDrawer } from '@angular/material/sidenav';
import { DetailsComponent } from './details/details.component';
import { CreateComponent } from './create/create.component';

@Component({
  selector: 'app-jobs',
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    JobCardComponent,
    DetailsComponent,
    CreateComponent
  ],
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.scss',
})
export class JobsComponent {
  private readonly _router = inject(Router);
  private readonly _jobService = inject(JobsService);

  jobs: WritableSignal<any[]> = signal([]);
  loading: WritableSignal<boolean> = signal(false);

  loaders: any = {
    manage: []
  }

  @ViewChild(MatDrawer) drawer!: MatDrawer;

  selected_job: WritableSignal<any> = signal(null);
  sidenavType: WritableSignal<'add-job' | 'details' | 'add-candidate'> = signal('add-job');

  ngOnInit(): void {
    this.loadJobs()
  }

  loadJobs() {
    this.loading.set(true);
    this._jobService.getJobs()
    .pipe(finalize(() => (this.loading.set(false))))
      .subscribe((jobs: any) => (this.jobs.set(jobs.data)));
  }

  openAddJobDialog() {
    this._router.navigate(['/jobs/create']);
  }

  deleteJob(id: number) {
    this._jobService.deleteJob(id).subscribe(() => this.loadJobs());
  }

  openDrawer(job: any) {
    this.sidenavType.set('details');
    this.selected_job.set(job);
    this.drawer.open();
  }
}
